// components/legal/PolicySection.jsx
import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { useRef } from 'react';

const PolicySection = ({ title, content, last = false }) => {
    const ref = useRef(null);
    const isInView = useInView(ref, { once: true, amount: 0.2 });

    return (
        <motion.section
            ref={ref}
            initial={{ opacity: 0, y: 40 }}
            animate={isInView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.8 }}
            className={`py-12 ${!last ? 'border-b border-charcoal/10' : ''}`}
        >
            <h2 className="font-cormorant text-2xl md:text-3xl text-charcoal mb-8">
                {title}
            </h2>
            <div className="space-y-6">
                {content.map((paragraph, index) => (
                    <motion.p
                        key={index}
                        initial={{ opacity: 0 }}
                        animate={isInView ? { opacity: 1 } : {}}
                        transition={{ duration: 0.6, delay: 0.1 * index }}
                        className="font-poppins text-charcoal/80 leading-relaxed"
                    >
                        {paragraph}
                    </motion.p>
                ))}
            </div>
        </motion.section>
    );
};

export default PolicySection;